import { useCallback } from 'react';
// very complicated to handle '-' enter with different browser behaviour regarding input type=number
var onlyNumbersRegex = /^[0-9]+[.,]?(?:[0-9]+)?$/;
var onlyIntegerRegex = /^[0-9]+$/;
export var useRestrictiveNumberHandlers = function (_a) {
    var onChange = _a.onChange, onKeyPress = _a.onKeyPress, onlyInteger = _a.onlyInteger, restrictInput = _a.restrictInput;
    var restrictedOnChange = useCallback(function (event) {
        var target = event.target;
        var value = target.value, validity = target.validity;
        var valid = validity.valid;
        if (valid || !restrictInput) {
            // In some browsers (IE, Samsung) the input number enable decimals value
            // on integer inputs
            target.value =
                target.value && onlyInteger ? parseInt(value, 10).toString() : value;
            onChange === null || onChange === void 0 ? void 0 : onChange(event);
        }
    }, [onChange, onlyInteger, restrictInput]);
    var restrictedOnKeyPress = useCallback(function (event) {
        var enterKeyPressed = event.keyCode === 13 || event.which === 13;
        var key = event.key || String.fromCharCode(event.charCode || event.which);
        var value = "".concat(event.target.value).concat(key);
        var regExp = onlyInteger ? onlyIntegerRegex : onlyNumbersRegex;
        var isValid = regExp.test(value);
        if (!isValid && !enterKeyPressed) {
            event.preventDefault();
        }
        onKeyPress === null || onKeyPress === void 0 ? void 0 : onKeyPress(event);
    }, [onKeyPress, onlyInteger]);
    return [restrictedOnChange, restrictedOnKeyPress];
};
//# sourceMappingURL=useRestrictiveNumberHandlers.js.map